import React, { Component } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTwitterSquare } from '@fortawesome/free-brands-svg-icons'
import { faFacebookSquare } from '@fortawesome/free-brands-svg-icons'

class Social extends Component {
    render() {
        return (
            <div>
                <div className="text-cetner">
                    <a href="https://twitter.com/EdgePokerApp" target="_blank" rel="noopener noreferrer" 
                        className="social-font black-color mr-3"
                        aria-label="Edge Poker Twitter Page">
                        <FontAwesomeIcon icon={faTwitterSquare} />
                    </a>
                    <a href="https://www.facebook.com/edgepokerapp" target="_blank" rel="noopener noreferrer" 
                        className="social-font black-color"
                        aria-label="Edge Poker Facebook Page">
                        <FontAwesomeIcon icon={faFacebookSquare} />
                    </a>
                </div>
            </div>
        )
    }
}

export default Social;